var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleCombinedView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4",
    width: 16.454,
    height: 14.337,
    fill: "none",
    viewBox: "0 0 16.454 14.337",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / file / file-code",
    transform: "translate(-9.3301 -13.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "m14.582 23.668 2.0035-2.0035-3.2483-3.2482 3.2483-3.2483-2.0035-2.0035-5.2517 5.2518zm5.951-6.67-2.0035 2.0035 3.2483 3.2483-3.2483 3.2482 2.0035 2.0035 5.2517-5.2517z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCombinedView);
export default __webpack_public_path__ + "static/media/toggle-combined-view.333621a51b9f83eab281f04588413014.svg";
export { ForwardRef as ReactComponent };